/**
 * @file useLocaleChange.ts
 * @description
 * -----------------------------------------------------
 * Hook personalizado para cambiar el idioma de la aplicación
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-06-02
 * @modified 2026-02-20
 * @author DLTCode
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useTransition } from "react";
import { toast } from "sonner";
import { Locale } from "@/features/i18n";
import { useSession } from "@/features/auth";
import { setUserLocale } from "@/features/i18n";
import { useRouter } from "@/features/i18n";
import { updateProfileLanguage } from "@/features/profile";
const useLocaleChange = () => {
  const $ = _c(6);
  const session = useSession();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  let t0;
  if ($[0] !== router || $[1] !== session) {
    t0 = async newLocale => {
      startTransition(async () => {
        let sessionUpdatePromise = Promise.resolve();
        let localeChangePromise = setUserLocale(newLocale);
        if (session.status === "authenticated") {
          const response = await updateProfileLanguage(newLocale);
          if (response.status !== 200 || !response.result?.user) {
            toast.error(response.message);
            return;
          }
          sessionUpdatePromise = session.update({
            ...response.result.user,
            language: newLocale
          });
          localeChangePromise = setUserLocale(newLocale);
        }
        await Promise.all([sessionUpdatePromise, localeChangePromise]);
        router.refresh();
      });
    };
    $[0] = router;
    $[1] = session;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleLocaleChange = t0;
  let t1;
  if ($[3] !== handleLocaleChange || $[4] !== isPending) {
    t1 = [isPending, handleLocaleChange];
    $[3] = handleLocaleChange;
    $[4] = isPending;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1 as const;
};
export default useLocaleChange;